export default __webpack_public_path__ + "static/media/plusBlue.0709f17f.svg";